import { contactFormParametersGeneration } from './contactFormParametersGeneration'
import { contactSaveParametersGeneration as frContactSaveParametersGeneration } from './FR/contactSaveParametersGeneration'
import { contactSaveParametersGeneration as beContactSaveParametersGeneration } from './BE/contactSaveParametersGeneration'
import { contactSaveParametersGeneration as nlContactSaveParametersGeneration } from './NL/contactSaveParametersGeneration'
import { contactSaveParametersGeneration as deContactSaveParametersGeneration } from './DE/contactSaveParametersGeneration'
import { contactSaveParametersGeneration as itContactSaveParametersGeneration } from './IT/contactSaveParametersGeneration'
import type { ContactSubscriptionData } from './contactSubscriptionData'

type GenerateContactParametersParams = {
  contactData: ContactSubscriptionData
  id: string | number
  country: string
  action: string
  doorToDoorPartnerChecklistCheckedTitles: Record<string, boolean>
  doorToDoorPartnerLeadSource: string
}

type ContactParametersGenerator = (parameters: GenerateContactParametersParams) => URLSearchParams

const parametersGeneratorByCountry: Record<string, ContactParametersGenerator> = {
  fr: frContactSaveParametersGeneration,
  be: beContactSaveParametersGeneration,
  nl: nlContactSaveParametersGeneration,
  de: deContactSaveParametersGeneration,
  it: itContactSaveParametersGeneration,
}

export function generateContactParameters(parameters: GenerateContactParametersParams): URLSearchParams {
  const generator = parametersGeneratorByCountry[parameters.country]

  if (generator) {
    return generator(parameters)
  }

  return contactFormParametersGeneration(parameters)
}
